export class LanguageUtil {

    public static toLangCode(examLanguage: string): string {
        if (!examLanguage) {
            return null;
        }
        const value = examLanguage.toLowerCase();
        if (value.startsWith('englisch') || value.startsWith('english')) {
            return 'en';
        }
        if (value.startsWith('deutsch') || value.startsWith('german')) {
            return 'de';
        }
        return null;
    }
}
